import controller from './draggable-item-controller';

const DraggableItemComponent: angular.IComponentOptions = {
  controller,
  controllerAs: 'ctrl',
  bindings: {
    value: '<',
    selected: '<',
    type: '<',
    contextId: '<?',
    additionalText: '@?',
    onSelect: '&?',
    onTrigger: '&?',
    onDragStart: '&?',
    onDragEnd: '&?',
  },
  template: `
    <span
      class="pill-label"
      ng-class="ctrl.getClassState()"
      ng-click="ctrl.trigger()">

      <!-- Draggable Pill Name Begins -->
      <span class="pill-name" title="{{ctrl.value}}">
        <span class="pill-name-label">{{ctrl.value}}</span>
        <span ng-if="ctrl.additionalText">({{ctrl.additionalText}})</span>
      </span>
      <!-- @Draggable Pill Name Ends -->

      <!-- Draggable Pill Dropdown Begins -->
      <a
        href="#"
        class="pill-trigger"
        ng-if="ctrl.isTypeDropdown()">
      </a>
      <!-- @Draggable Pill Dropdown Ends -->

    </span>
  `,
};

export { DraggableItemComponent };
